// RTK have it's own actions. These action creaters are specifically for sagas
import { createAction } from '@reduxjs/toolkit';
export const getProjectMembers = createAction('members/saga/get-project-members');
export const createMember = createAction('members/saga/create-account-member');
export const getMembers = createAction('members/saga/get-members');
export const deactivateMemberAction = createAction('@@members/deactivateMember');
export const reactivateMemberAction = createAction('@@members/reactivateMember');
export const inviteMembersAction = createAction('@@members/inviteMembers');
export const reinviteMembersAction = createAction('@@members/reinviteMembers');
export const updateMemberAction = createAction('@@members/updateMember');
